import parse from 'utils/parse';

const makeTestId = (...ids: string[]): string => parse.toTestId('landing', ...ids);

const testId = Object.freeze({
  page: makeTestId(),
});

const config = {
  returnUserCookie: 'returnUser',
  notConvincedSticky: {
    scrollMultiplier: 2,
    headerOffset: 48,
    headerOffsetMobile: 56,
  },
};

export { testId, config };
